<div fxLayout="row">
    <div class="snack-icon">
        <vsc-icon [icon]="getIcon()"></vsc-icon>
    </div>
    <div class="snack-message">
        <span [innerHtml]="data.message"></span>
    </div>
</div>
